<button
  #button
  type="button"
  [class]="buttonClasses()"
  (click)="submit()"
  [disabled]="disabled()"
>
  <div [class]="textClasses()">{{ label() }}</div>
</button>
